import AuthenticatedLayout from '../../components/AuthenticatedLayout'
import { Link, router } from '@inertiajs/react'

function formatCurrency(amount) {
  return new Intl.NumberFormat('sv-SE', { style: 'currency', currency: 'SEK' }).format(amount || 0)
}

function formatDate(isoString) {
  return new Date(isoString).toLocaleDateString('sv-SE')
}

export default function Order({ store, order, can_mark_paid }) {
  function markAsPaid() {
    router.patch(`/stores/${store.id}/orders/${order.id}`)
  }

  return (
    <AuthenticatedLayout>
      <div className="space-y-6">
        <Link href={`/stores/${store.id}/orders`} className="text-sm text-indigo-600 hover:underline">
          ← Tillbaka till beställningar
        </Link>

        <div className="flex items-start justify-between">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">
              Beställning #{order.id}
            </h1>
            <p className="mt-1 text-sm text-gray-500">
              {store.user_name} · {store.activity_name} · {formatDate(order.created_at)}
            </p>
          </div>
          <div>
            {can_mark_paid ? (
              order.status === 'paid' ? (
                <button
                  onClick={markAsPaid}
                  className="inline-flex items-center px-4 py-2 rounded-lg bg-green-100 text-green-800 text-sm font-medium hover:bg-green-200"
                >
                  Betald — ångra
                </button>
              ) : (
                <button
                  onClick={markAsPaid}
                  className="inline-flex items-center px-4 py-2 rounded-lg bg-indigo-600 text-white text-sm font-medium hover:bg-indigo-700"
                >
                  Markera som betald
                </button>
              )
            ) : order.status === 'paid' ? (
              <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-green-100 text-green-800">
                Betald
              </span>
            ) : (
              <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-gray-100 text-gray-600">
                Ej betald
              </span>
            )}
          </div>
        </div>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
          <div className="bg-white rounded-xl border border-gray-200 p-4 space-y-1">
            <h2 className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-3">Kund</h2>
            <p className="text-sm font-medium text-gray-900">{order.customer_name}</p>
            <p className="text-sm text-gray-500">{order.customer_email}</p>
          </div>
        </div>

        <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
          <h2 className="px-4 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wide bg-gray-50">Artiklar</h2>
          <table className="w-full text-left">
            <thead className="border-t border-gray-100 text-xs text-gray-500 uppercase tracking-wide bg-gray-50">
              <tr>
                <th className="px-4 py-3">Artikel</th>
                <th className="px-4 py-3 text-right">Pris</th>
                <th className="px-4 py-3 text-right">Antal</th>
                <th className="px-4 py-3 text-right">Delsumma</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {order.items.map((item, index) => (
                <tr key={index}>
                  <td className="px-4 py-3 text-sm text-gray-900">{item.name}</td>
                  <td className="px-4 py-3 text-sm text-gray-500 text-right whitespace-nowrap">{formatCurrency(item.price)}</td>
                  <td className="px-4 py-3 text-sm text-gray-500 text-right">{item.quantity}</td>
                  <td className="px-4 py-3 text-sm font-medium text-gray-900 text-right whitespace-nowrap">{formatCurrency(item.subtotal)}</td>
                </tr>
              ))}
            </tbody>
            <tfoot className="border-t border-gray-200 bg-gray-50">
              <tr>
                <td colSpan={3} className="px-4 py-3 text-sm font-semibold text-gray-900 text-right">Totalt</td>
                <td className="px-4 py-3 text-sm font-bold text-gray-900 text-right whitespace-nowrap">{formatCurrency(order.total)}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </AuthenticatedLayout>
  )
}
